module.exports = __webpack_public_path__ + "static/media/live-roulette.3387dcf3.svg";